import type { FC } from 'react';

import { Button, Heading, RadioGroup, RadioTile, Stretch } from '@eneco/sparky';
import { useTracking } from '@eneco/tracking';
import { useContent } from '@sitecore/common';
import { PriceSimulationRenderingExtended } from '@sitecore/types/manual/be/PriceSimulationExtended';
import { Controller, useFormContext } from 'react-hook-form';

import { PriceSimulationFormSchema } from '../schemas/priceSimulationFormSchema';
import { FlowChildProps } from '../types/PriceSimulationSteps';

export const ProspectStep: FC<FlowChildProps> = ({ nextMainStep }) => {
  const { fields } = useContent<PriceSimulationRenderingExtended>();
  const { trackEventBE } = useTracking();

  const {
    control,
    trigger,
    getValues,
    formState: { errors },
  } = useFormContext<PriceSimulationFormSchema>();

  const onNextClick = async () => {
    const isValid = await trigger('isProspect');
    if (!isValid) {
      return;
    }
    const isProspect = getValues('isProspect');
    trackEventBE('pbt_client_status', { data: { isProspect } });
    nextMainStep();
  };

  return (
    <>
      <Heading as="h1" size="M">
        {fields.customerQuestionStep.title.value}
      </Heading>
      <Stretch>
        <div>
          <Controller
            control={control}
            name={'isProspect'}
            render={({ field: { onChange, value } }) => (
              <RadioGroup
                aria-labelledby={fields.customerQuestionStep.customerTypesList.value.label}
                direction="column"
                error={
                  errors.isProspect?.message
                    ? fields.customerQuestionStep.customerTypesList.value.requiredMessage
                    : undefined
                }
                value={value ? 'notACustomer' : value === false ? 'alreadyCustomer' : undefined}
                onValueChange={val => onChange(val === undefined ? undefined : val === 'notACustomer')}
                name="isProspect">
                {fields.customerQuestionStep.customerTypesList.value.options.map(option => (
                  <RadioTile key={option.name} value={option.name}>
                    {option.label}
                  </RadioTile>
                ))}
              </RadioGroup>
            )}
          />
        </div>
      </Stretch>
      <Button onClick={onNextClick}>{fields.navigation.nextButtonText.value}</Button>
    </>
  );
};
